import { SVGProps } from '../types';

const JCBIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M29.309 15.9391C30.0174 15.9545 30.7298 15.9078 31.4353 15.9633C32.1498 16.0966 32.322 17.1782 31.6872 17.5325C31.2541 17.7659 30.7396 17.6194 30.2701 17.6606H29.309V15.9391ZM31.8449 13.9905C32.0022 14.546 31.4668 15.0448 30.9318 14.9683H29.309C29.3204 14.4444 29.2868 13.8758 29.3255 13.3796C29.9756 13.3979 30.6316 13.3422 31.2779 13.4087C31.5556 13.4784 31.788 13.7067 31.8449 13.9905ZM35.7501 5.75272C35.7803 6.81358 35.7545 7.9305 35.7631 9.01287C35.7611 13.4134 35.7674 17.8138 35.7597 22.2146C35.7312 23.8638 34.2696 25.2968 32.6318 25.3297C30.9924 25.3364 29.3528 25.3308 27.7132 25.3326V18.6799C29.4996 18.6707 31.287 18.6986 33.0727 18.666C33.901 18.614 34.8084 18.0674 34.847 17.1558C34.9445 16.2402 34.0813 15.6069 33.2618 15.5069C32.9468 15.4987 32.956 15.4151 33.2618 15.3786C34.0434 15.2097 34.6572 14.4007 34.4273 13.5905C34.2313 12.7383 33.2894 12.4085 32.506 12.4101C30.9087 12.3993 29.311 12.4086 27.7136 12.4055C27.7239 11.1635 27.692 9.92018 27.7307 8.67912C27.8573 7.05968 29.3557 5.72417 30.9704 5.75315C32.5639 5.75291 34.157 5.75291 35.7501 5.75285V5.75272Z"
      fill="url(#paint0_linear_1_12883)"
    />
    <path
      d="M9.66212 8.84678C9.70291 7.20019 11.1707 5.77891 12.8064 5.75484C14.4397 5.74981 16.0733 5.75411 17.7066 5.75266C17.7021 11.2618 17.7155 16.7716 17.6999 22.2804C17.637 23.907 16.1851 25.3012 14.5673 25.33C12.9309 25.3359 11.2943 25.3308 9.65781 25.3325V18.4555C11.2474 18.831 12.9143 18.9909 14.5359 18.7418C15.5052 18.5858 16.5658 18.1098 16.8939 17.1042C17.1354 16.244 16.9995 15.3386 17.0354 14.4558V12.4054H14.229C14.2164 13.7615 14.2549 15.1199 14.2087 16.4743C14.1331 17.3068 13.3086 17.8358 12.5235 17.8075C11.5497 17.8178 9.62011 17.1018 9.62011 17.1018C9.61526 14.5611 9.64836 11.3793 9.66212 8.84702V8.84678Z"
      fill="url(#paint1_linear_1_12883)"
    />
    <path
      d="M18.753 13.2325C18.6053 13.2638 18.7233 12.7293 18.6855 12.5265C18.6956 11.2445 18.6645 9.96106 18.7027 8.67993C18.8289 7.05364 20.3388 5.7148 21.9601 5.75287H26.7347C26.7302 11.262 26.7435 16.7718 26.728 22.2806C26.665 23.9072 25.2131 25.3013 23.5952 25.3302C21.9587 25.3364 20.3221 25.3312 18.6855 25.3327V17.7981C19.8032 18.7151 21.3223 18.8579 22.7148 18.8604C23.7645 18.86 24.8082 18.6982 25.8276 18.4561V17.0757C24.6787 17.6483 23.3282 18.012 22.0547 17.683C21.1663 17.4619 20.5214 16.6033 20.5357 15.6865C20.4328 14.7331 20.9917 13.7265 21.9286 13.443C23.0919 13.0788 24.3598 13.3574 25.4502 13.8308C25.6838 13.9532 25.9209 14.1049 25.8275 13.7144V12.6294C24.0038 12.1955 22.063 12.0359 20.2308 12.5079C19.7005 12.6575 19.1838 12.8844 18.753 13.2326V13.2325Z"
      fill="url(#paint2_linear_1_12883)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_12883"
        x1="27.6582"
        y1="15.124"
        x2="35.7124"
        y2="15.124"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#58B03A" />
        <stop offset="1" stop-color="#55B330" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_12883"
        x1="9.48657"
        y1="15.7301"
        x2="17.5747"
        y2="15.7301"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0F6EB6" />
        <stop offset="1" stop-color="#006DBA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_12883"
        x1="18.6737"
        y1="15.3138"
        x2="26.7332"
        y2="15.3138"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DE0D3D" />
        <stop offset="1" stop-color="#E30138" />
      </linearGradient>
    </defs>
  </svg>
);

export { JCBIcon };
